export default {
  getUserData(state) {
    return state.userData
  },

  getUserId(state) {
    return state.userId
  },
}
